import { createApi } from "@reduxjs/toolkit/dist/query/react"

import { baseQuery, getTags } from "../api"
import { getQueryString } from "../../common/utils"
import {
  PRICING_PROFILE_ENDPOINT,
  RTK_SLICE_API_LIST
} from "../../common/constants"
import {
  PricingProfileEntity,
  CreatePricingProfilePayload,
  UpdatePricingProfilePayload
} from "../../types"
import bbApi from "../../api"

const reducerPath = "pricing-profiles"

export const pricingProfilesApi = createApi({
  reducerPath,
  baseQuery,
  tagTypes: [reducerPath],
  endpoints: builder => ({
    findPricingProfiles: builder.query({
      query: (params: { brand_id: string }) =>
        `${PRICING_PROFILE_ENDPOINT}${getQueryString(params)}`,
      transformResponse: (responseData: PricingProfileEntity[] | any) =>
        Array.isArray(responseData) ? responseData : [],
      providesTags: result => getTags(reducerPath, "id", result)
    }),
    createPricingProfile: builder.mutation({
      queryFn: async (data: CreatePricingProfilePayload) => {
        const response = await bbApi.profile.create(data)
        if (response.status === "error") {
          return { error: { status: 200, data: response } }
        }
        return { data: response }
      },
      invalidatesTags: [{ type: reducerPath, id: RTK_SLICE_API_LIST }]
    }),
    updatePricingProfile: builder.mutation({
      queryFn: async (data: UpdatePricingProfilePayload) => {
        const response = await bbApi.profile.update(data)
        if (response.status === "error") {
          return { error: { status: 200, data: response } }
        }
        return { data: response }
      },
      invalidatesTags: [{ type: reducerPath, id: RTK_SLICE_API_LIST }]
    }),
    deletePricingProfile: builder.mutation({
      queryFn: async (id: string) => {
        const response = await bbApi.profile.delete(id)
        if (response.status === "error") {
          return { error: { status: 200, data: response } }
        }
        return { data: response }
      },
      invalidatesTags: [{ type: reducerPath, id: RTK_SLICE_API_LIST }]
    })
  })
})

export const {
  useFindPricingProfilesQuery,
  useCreatePricingProfileMutation,
  useUpdatePricingProfileMutation,
  useDeletePricingProfileMutation
} = pricingProfilesApi
